export default __webpack_public_path__ + "static/media/stock_depot_exemplaire.6d09b7fd.xlsx";